
import React from 'react';
import { Message } from './types';
import ChatHeader from './ChatHeader';
import ChatMessageList from './ChatMessageList';
import ChatInput from './ChatInput';

interface ChatbotPanelProps {
  isMinimized: boolean;
  useTelegram: boolean;
  messages: Message[];
  onToggleMinimize: () => void;
  onToggleChat: () => void;
  onToggleTelegram: () => void;
  onSendMessage: (message: string) => void;
  isLoading?: boolean;
  chatId?: string;
}

const ChatbotPanel: React.FC<ChatbotPanelProps> = ({
  isMinimized,
  useTelegram,
  messages,
  onToggleMinimize,
  onToggleChat,
  onToggleTelegram,
  onSendMessage,
  isLoading = false,
  chatId = ''
}) => {
  return (
    <div 
      className={`bg-white rounded-2xl shadow-xl transition-all duration-300 ease-in-out overflow-hidden flex flex-col ${
        isMinimized 
          ? 'w-72 h-16' 
          : 'w-80 sm:w-96 h-[500px]'
      }`}
    >
      <ChatHeader 
        isMinimized={isMinimized}
        useTelegram={useTelegram}
        onToggleMinimize={onToggleMinimize}
        onToggleChat={onToggleChat}
        onToggleTelegram={onToggleTelegram}
        chatId={chatId}
      />
      
      {!isMinimized && (
        <>
          <ChatMessageList messages={messages} />
          <ChatInput 
            onSendMessage={onSendMessage}
            useTelegram={useTelegram}
            isLoading={isLoading}
          />
        </>
      )}
    </div>
  );
};

export default ChatbotPanel;
